import React, { Component } from 'react';
import { Link, useNavigate, useParams, useLocation } from "react-router-dom";
import ProductCard from "../../customComponents/productCard/productCard";
import { Button, CircularProgress, Divider, Grid, Breadcrumbs, Typography } from "@mui/material";
import LinkMui from '@mui/material/Link';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBoxOpen } from "@fortawesome/free-solid-svg-icons/faBoxOpen";
import { Pagination } from "@mui/lab";
import { Product } from "../../../classes/types/product/product";
import { CategoryLink } from "../../../classes/types/category/category";
import { ProductHandler } from "../../../classes/methods/productMethods/productMethods";
import { CategoryHandler } from "../../../classes/methods/categoryMethods/categoryMethods";
import FilterPage from "../../customComponents/filterPage/filterPage";

interface Props {
  categoryCode: string;
  categoryId: string;
  page?: string;
  navigate?: any;
  params?: any;
  location?: any;
}

interface State {
  productsToView: Array<Product>;
  loading: boolean;
  categoryLinks: Array<CategoryLink>;
  selectedCategory: string;
  products: Array<Product>;
  pageProducts: Array<Product>;
  currentPage: number;
  pageNumber: number;
  numberProductsInPage: number;
  error: string;
  isLogged: boolean;
}

class CategoryView extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      products: [],
      productsToView: [],
      loading: true,
      categoryLinks: [],
      selectedCategory: '',
      pageProducts: [],
      numberProductsInPage: 20,
      currentPage: props.page ? Number(props.page) : 1,
      pageNumber: 1,
      error: '',
      isLogged: false,
    }
  }

  componentDidMount() {
    this.refreshData();
  }

  componentDidUpdate(prevProps: Readonly<Props>) {
    if (prevProps.location !== this.props.location || prevProps.categoryCode !== this.props.categoryCode) {
      this.refreshData();
    }
  }

  refreshData = () => {
    this.setState({ loading: true });

    CategoryHandler.getCategoryByCode(this.props.categoryCode).then(category => {
      this.setState({ selectedCategory: category.name });
    });

    ProductHandler.getProductsByCategoryCode(this.props.categoryCode).then(newProducts => {
      if (newProducts !== null) {
        newProducts.sort((a, b) => a.price - b.price);
        let productsCopy = newProducts.length;
        let newPageNumber = 0;
        while (productsCopy > 0) {
          productsCopy -= this.state.numberProductsInPage;
          newPageNumber++;
        }
        let startingProduct = this.props.page ? (Number(this.props.page) - 1) * this.state.numberProductsInPage : 0;
        let lastProduct = this.props.page ? this.state.numberProductsInPage * Number(this.props.page) : this.state.numberProductsInPage;

        if (this.props.page !== undefined && (Number(this.props.page) <= 0 || Number(this.props.page) > newPageNumber || isNaN(Number(this.props.page)))) {
          this.onPageChange(null, 1);
        }

        this.setState({
          products: newProducts,
          productsToView: newProducts,
          loading: false,
          pageProducts: newProducts.slice(startingProduct, lastProduct),
          pageNumber: newPageNumber,
          isLogged: this.isLogged(newProducts),
        });
      }
    }).catch(err => {
      this.setState({ loading: false, error: "La categoria selezionata non esiste" });
      console.log(err);
    });
  }

  onPageChange = (e: any, page: any) => {
    this.props.navigate(`/shop/category/${this.props.categoryCode}/page/${page}`);
    const startingPoint = (page - 1) * this.state.numberProductsInPage;
    const newProductsPage = this.state.productsToView.slice(startingPoint, startingPoint + this.state.numberProductsInPage);
    this.setState({ pageProducts: newProductsPage, currentPage: page });
  }

  isLogged = (products: Array<Product>) => {
    let isLogged = false;
    if (products.length > 0) {
      products.every(product => {
        if (!product.configurable && product.price !== undefined) {
          isLogged = true;
          return false;
        }
        return true;
      });
    }
    return isLogged;
  }

  onProductsFiltered = (newProductsToView: Product[]) => {
    const { numberProductsInPage } = this.state;

    const newPageNumber = Math.ceil(
      newProductsToView.length / numberProductsInPage
    );

    const newProductsPage = newProductsToView.slice(
      0,
      numberProductsInPage
    );

    window.history.pushState(
      null,
      "",
      `/shop/category/${this.props.categoryCode}/page/1`
    );

    this.setState({
      productsToView: newProductsToView,
      pageProducts: newProductsPage,
      pageNumber: newPageNumber,
      currentPage: 1,
    });
  };

  render() {
    const { loading, pageProducts, products, selectedCategory, pageNumber, currentPage, isLogged, error } = this.state;

    return (
      <div className="category-view">
        <Grid container>
          <Grid xs={2} item>
            <div style={{ backgroundColor: "white", height: "40px" }}>
              <div style={{ paddingLeft: "2%", width: "fit-content", paddingTop: "1%", paddingBottom: "1%", position: "fixed", backgroundColor: "white" }}>
                <Breadcrumbs aria-label="breadcrumb">
                  <LinkMui underline="hover" color="inherit"><Link to="/">HOME</Link></LinkMui>
                  <Typography style={{ color: 'black' }}>{selectedCategory}</Typography>
                </Breadcrumbs>
              </div>

            </div>
            <FilterPage isLogged={isLogged} selectedCategory={selectedCategory} products={products} loading={loading} category={false} onProductsFiltered={this.onProductsFiltered} />
          </Grid>
          <Grid xs={10} style={{ paddingLeft: '2%' }} item>
            {loading ? <CircularProgress /> : (pageProducts.length > 0 ? (
              <div>
                <Divider variant="middle" style={{ marginBottom: '0.5%' }} />
                {pageProducts.map(product => (
                  <div key={product.id} style={{ marginRight: "2%" }}>
                    <ProductCard isLogged={isLogged} linkName={`/shop/category/${this.props.categoryCode}/page/${currentPage}/prodotto/${product.id}`} loading={loading} product={product} />
                    <Divider variant="middle" />
                  </div>

                ))}
                <div style={{ marginLeft: "2%", width: "100%", marginTop: "2%", display: "flex", justifyContent: "center" }}>
                  <Pagination color="primary" count={pageNumber} page={currentPage} onChange={this.onPageChange} />
                </div>
              </div>
            ) : (
              products.length > 0 ? (
                <div style={{ marginTop: '10%' }}>
                  <FontAwesomeIcon style={{ marginTop: "10px", color: "grey", fontSize: "10vw" }} icon={faBoxOpen} />
                  <h1>Non esistono prodotti con queste specifiche</h1>
                </div>
              ) : (
                <div style={{ marginTop: '10%' }}>
                  <FontAwesomeIcon style={{ marginTop: "10px", color: "grey", fontSize: "10vw" }} icon={faBoxOpen} />
                  <h1>{error !== '' ? error : "Non esistono prodotti in questa categoria"}</h1>
                  <Link to={'/'}><Button variant="contained" color="primary">Ritorna alla Pagina Iniziale</Button></Link>
                </div>
              )
            ))}
          </Grid>
        </Grid>
      </div>
    );
  }
}

// Wrapper funzionale per React Router v6
export default function CategoryViewWrapper(props: any) {
  const navigate = useNavigate();
  const params = useParams();
  const location = useLocation();
  return <CategoryView {...props} navigate={navigate} params={params} location={location} />;
}
